import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['inviteLink', 'nameInput', 'nameCount', 'descriptionInput', 'descriptionCount']

  connect() {
    // Initialize character counts if inputs exist
    if (this.hasNameInputTarget) {
      this.updateNameCount()
    }
    if (this.hasDescriptionInputTarget) {
      this.updateDescriptionCount()
    }
  }

  copyInviteLink() {
    if (!this.hasInviteLinkTarget) return

    const link = this.inviteLinkTarget.value

    navigator.clipboard.writeText(link).then(() => {
      this.showNotification('Invite link copied to clipboard', 'success')
    }).catch(() => {
      // Fallback for older browsers
      this.inviteLinkTarget.select()
      document.execCommand('copy')
      this.showNotification('Invite link copied to clipboard', 'success')
    })
  }

  updateNameCount() {
    if (!this.hasNameInputTarget || !this.hasNameCountTarget) return

    const count = this.nameInputTarget.value.length
    this.nameCountTarget.textContent = count

    if (count > 100) {
      this.nameCountTarget.classList.add('text-red-600')
    } else {
      this.nameCountTarget.classList.remove('text-red-600')
    }
  }

  updateDescriptionCount() {
    if (!this.hasDescriptionInputTarget || !this.hasDescriptionCountTarget) return

    const count = this.descriptionInputTarget.value.length
    this.descriptionCountTarget.textContent = count

    if (count > 500) {
      this.descriptionCountTarget.classList.add('text-red-600')
    } else {
      this.descriptionCountTarget.classList.remove('text-red-600')
    }
  }

  showNotification(message, type) {
    const notification = document.createElement('div')
    notification.className = `fixed top-4 right-4 z-50 p-4 rounded border-2 ${
      type === 'success' ?
        'bg-green-50 border-green-500 text-green-700' :
        'bg-red-50 border-red-500 text-red-700'
    }`
    notification.textContent = message

    document.body.appendChild(notification)

    setTimeout(() => {
      notification.remove()
    }, 3000)
  }
}
